// Core
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../../Middleware/axiosConfig";

// Utils
import { notifyError } from "Services/Utils/toastNotification";

// API End Points
import { API_END_POINTS } from "Middleware/apiEndpoints";

// API calls
// To get the approval list
export const getApprovalListRequest_ACCESSOR = createAsyncThunk(
  "getApprovalListRequest_ACCESSOR",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getApprovalListRequest_ACCESSOR}${data?.page}&limit=${data?.limit}&order_by=${data?.orderBy}&sort_by=${data?.sortBy}${data?.search ? `&search=${data.search}` : ''}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

// To get the spare parts log data
export const getSparePartsLog = createAsyncThunk(
  "getSparePartsLog",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getSparePartsLog}/${data?.assessment_id}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
); 

export const addApproverFeedback = createAsyncThunk(
  "addApproverFeedback",
  async (data) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.approverFeedback}?&assessment_id=${data?.assessment_id}&category_id=${data?.category_id}&sub_category_id=${data?.sub_category_id}&question_id=${data?.question_id}`,
      data?.body
    );
    if (response?.status === 200 || response?.status === 201) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

// Assessment Approve Reject
export const addApproveReject = createAsyncThunk(
  "assessmentApproveReject",
  async (data) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.assessmentApproveReject}/${data?.assessment_id}`,
      data?.body
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

const approverSlice = createSlice({
  name: "approver",
  initialState: { isLoading: false },
  reducers: {},
  extraReducers: (builder) => {
    //Get all staffs request
    // To get the approval list
    builder
      .addCase(getApprovalListRequest_ACCESSOR.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(getApprovalListRequest_ACCESSOR.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(getApprovalListRequest_ACCESSOR.rejected, (state, action) => {
        state.isLoading = "failed";
      });
  },
});

export default approverSlice.reducer;
